<template>
  <section class="vue-workplace-search">
    <div class="vue-workplace-search__search" v-if="!isEdit">
      <div class="edit-section">
        <h4>
          <template v-if="membershipStatusType.value !== 'RET'"
            >Your current workplace details</template
          >
          <template v-else>Your last workplace details</template>
        </h4>
        <button @click="setIsEdit(true)" role="button" class="btn btn--default">
          Edit
        </button>
      </div>
      <div class="review-section">
        <p>
          <strong>{{ chosenWorkplace.name }}</strong>
        </p>
        <p>{{ chosenWorkplace.trustName }}</p>
        <p>{{ chosenWorkplace.regionName }}</p>
      </div>
    </div>
    <div class="vue-workplace-search__search" v-else>
      <div class="edit-section">
        <h3>Start typing below to find your employer</h3>
        <button
          v-if="chosenWorkplace.name"
          @click="setIsEdit(false)"
          role="button"
          class="btn btn--default"
        >
          Cancel
        </button>
      </div>
      <input
        type="text"
        v-model="searchTerm"
        placeholder="Type here to search for your place of work"
        :class="[{ 'has-errors': hasError }]"
      />
      <span v-if="hasError" class="validation-label">
        This field is required
      </span>
      <div class="employer-list-wrap">
        <ul class="employer-list" v-if="workplaces.length > 0">
          <li
            class="employer-list__item employer-list-item"
            v-for="workplace in workplaces"
            :key="workplace.id"
          >
            <div class="employer-list-item__text">
              <h4>{{ workplace.name }}</h4>
              <p v-html="workplace['@search.text']"></p>
              <button
                class="btn btn--positive"
                @click="submit(workplace)"
                role="button"
              >
                Select
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="form-control-item form-control-item--checkbox"
      style="cursor: pointer; margin-bottom: 24px;"
    >
      <input
        v-model="isAgencyWorker"
        id="isAgencyWorker"
        type="checkbox"
        @change="setIsAgencyWorker(isAgencyWorker)"
      />
      <label for="isAgencyWorker">
        If you do not hold a current contract of employment with the NHS under
        Agenda for change terms and conditions, please tick this box.
      </label>
    </div>
  </section>
</template>

<script>
import { useMemberDetails } from "@/helpers/member-details";
import { useWorkplaceSearch } from "@/helpers/workplace-search";
import { ref, watch } from "@vue/composition-api";
export default {
  props: ["hasError"],
  setup(_, { emit }) {
    const {
      workplaces,
      doSearch,
      selectWorkplace,
      chosenWorkplace,
      isAgencyWorker,
      setIsAgencyWorker,
    } = useWorkplaceSearch();
    const searchTerm = ref("");
    const isEdit = ref(!chosenWorkplace.workplaceId);
    const { membershipStatusType } = useMemberDetails();
    watch(
      () => searchTerm.value,
      (val) => {
        doSearch(val);
      },
    );

    function setIsEdit(truthy) {
      isEdit.value = truthy;
    }

    async function submit(workplace) {
      selectWorkplace(workplace);
      emit("selected-employer");
      isEdit.value = false;
    }

    return {
      searchTerm,
      workplaces,
      submit,
      chosenWorkplace,
      setIsEdit,
      isEdit,
      isAgencyWorker,
      setIsAgencyWorker,
      membershipStatusType,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/global-variables";
.has-errors {
  border-color: var(--error);
}
input,
label {
  display: block;
}
input {
  background-color: var(--white);
  border: 1px solid var(--mid-grey);
  border-radius: 3px;
  box-sizing: border-box;
  padding: 12px 16px;
  width: 100%;
  &:focus {
    border: 1px solid var(--primary);
  }
}
label {
  margin-bottom: 8px;
}
.edit-section {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.employer-list-wrap {
  min-height: 24px;
  max-height: 400px;
  overflow: hidden;
  position: relative;
  &::after {
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    bottom: 0;
    content: "";
    height: 80px;
    left: 0;
    position: absolute;
    width: 100%;
  }
}
.employer-list {
  height: 100%;
  list-style: none;
  margin: 0;
  margin-top: 24px;
  margin-right: -16px;
  overflow-y: scroll;
  position: relative;
  padding: 0;
  padding-right: 16px;
  margin-bottom: 56px;
}
.employer-list-item {
  align-items: flex-start;
  border-bottom: 1px solid var(--mid-grey);
  display: flex;
  margin-bottom: 24px;
  padding-bottom: 24px;
  &:last-of-type {
    padding-bottom: 80px;
  }
  .employer-list-item__img {
    flex-basis: 30%;
    margin-right: 24px;
    img {
      max-width: 100%;
    }
  }
  .employer-list-item__text {
    h4 {
      margin-top: 0;
    }
  }
}
</style>
